<mat-dialog-content>
  <mat-tab-group (selectedIndexChange)="loadDataForSelected($event)" mat-align-tabs="start">
    @for (tab of tabs; track tab) {
      <mat-tab [label]="tab">
        <mat-card>
          <table mat-table [dataSource]="dataSource.data" class="full-width-table container">
            <!-- jobID Column -->
            <ng-container matColumnDef="jobID">
              <th mat-header-cell *matHeaderCellDef>{{'printerTableViewPrinterDialog.tableId' | translate}}
              </th>
              <td mat-cell *matCellDef="let row">{{row.jobID}}</td>
            </ng-container>
            <!-- jobName Column -->
            <ng-container matColumnDef="jobName">
              <th mat-header-cell *matHeaderCellDef>{{'printerTableViewPrinterDialog.tableName' | translate}}
              </th>
              <td mat-cell *matCellDef="let row">{{row.jobName}}</td>
            </ng-container>
            <!-- userName Column -->
            <ng-container matColumnDef="userName">
              <th mat-header-cell *matHeaderCellDef>{{'printerTableViewPrinterDialog.tableUser' | translate}}
              </th>
              <td mat-cell *matCellDef="let row" class="align-center">{{row.userName}}</td>
            </ng-container>
            <!-- size Column -->
            <ng-container matColumnDef="size">
              <th mat-header-cell *matHeaderCellDef>{{'printerTableViewPrinterDialog.tableSize' | translate}}
              </th>
              <td mat-cell *matCellDef="let row" class="align-center">{{row.size}}</td>
            </ng-container>
            <!-- pagesPrinted Column -->
            <ng-container matColumnDef="pagesPrinted">
              <th mat-header-cell *matHeaderCellDef>{{'printerTableViewPrinterDialog.tablePages' | translate}}
              </th>
              <td mat-cell *matCellDef="let row" class="align-center">{{row.pagesPrinted}}</td>
            </ng-container>
            <!-- jobState Column -->
            <ng-container matColumnDef="jobState">
              <th mat-header-cell *matHeaderCellDef>
              {{'printerTableViewPrinterDialog.tableStatus' | translate}}</th>
              <td mat-cell *matCellDef="let row">{{row.jobState}}</td>
            </ng-container>
            <!-- actions Column -->
            <ng-container matColumnDef="actions">
              <th mat-header-cell *matHeaderCellDef>
              {{'printerTableViewPrinterDialog.tableActions' | translate}}</th>
              <td mat-cell *matCellDef="let row">
                @if (this.activePrintJobStates.includes(row.jobState)) {
                  <div>
                    @if (this.data.classMembers.length > 0) {
                      <button mat-icon-button
                        matTooltip="{{'printJobToolTips.moveJob' | translate}}" [matMenuTriggerFor]="printerSelectMenu">
                        <mat-icon>move_to_inbox</mat-icon>
                      </button>
                    }
                    <mat-menu #printerSelectMenu="matMenu">
                      @for (classMember of this.data.classMembers; track classMember) {
                        <button mat-menu-item (click)="moveJob(row.jobID, classMember)"
                          >
                          <mat-icon>printer</mat-icon>
                          {{classMember}}
                        </button>
                      }
                    </mat-menu>
                    @if (row.jobState !== 'PENDING_HELD') {
                      <button mat-icon-button
                        (click)="holdJob(row.jobID)" matTooltip="{{'printJobToolTips.holdJob' | translate}}">
                        <mat-icon>pause_circle_outline</mat-icon>
                      </button>
                    }
                    @if (row.jobState == 'PENDING_HELD') {
                      <button mat-icon-button
                        (click)="releaseJob(row.jobID)" matTooltip="{{'printJobToolTips.releaseJob' | translate}}">
                        <mat-icon>play_circle_outline</mat-icon>
                      </button>
                    }
                    <button mat-icon-button (click)="cancelJob(row.jobID)" matTooltip="{{'printJobToolTips.cancelJob' | translate}}">
                      <mat-icon>clear</mat-icon>
                    </button>
                  </div>
                }
              </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
          </table>
        </mat-card>
      </mat-tab>
    }
  </mat-tab-group>
</mat-dialog-content>